/**
 * `document.currentScript` is only meaningful while the script is executing, so
 * it is captured at module evaluation time and used later to locate sibling
 * assets such as the overlay bundle.
 */
export const HOST_SCRIPT_SRC: string | null =
  typeof document !== 'undefined' && document.currentScript
    ? ((document.currentScript as HTMLScriptElement).src ?? null) || null
    : null;

export const OVERLAY_FILENAME = 'siteflow-overlay.js';

export function resolveOverlayUrl(explicit?: string): string {
  if (explicit) return explicit;
  if (HOST_SCRIPT_SRC) return HOST_SCRIPT_SRC.replace(/[^/]*$/, OVERLAY_FILENAME);
  return OVERLAY_FILENAME;
}
